import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.CompanyRequestsListPage', {
    tutorialContent:
        'Approve or reject the request instantly.{br}Use ⚡️ to force your decision without waiting for other approvers.',
});
